import styled from 'styled-components'
import TransitionLink from 'gatsby-plugin-transition-link'
import { colors } from '@styles/vars/colors.style'
import { cubicBezier } from '@styles/vars/cubicBezier.style'

export const PageTransitionLinkMain = styled(TransitionLink)`
  display: inline-flex;
  color: currentColor;
  text-decoration: none;
  border: none;
  transition: color 0.3s ${cubicBezier.inOut};

  &:hover {
    color: ${colors.blue};
  }

  ${({ fill }) => {
    if (fill) {
      return `
        &:before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: block;
          height: auto;
        }
      `
    }
  }}
`
